module.exports = __webpack_public_path__ + "static/media/Story.1b284d84.jpg";